import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import 'firebase/firestore'
import {db} from '../db'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    episodes: []
  },
  mutations: vuexfireMutations,
  actions: {
    bindEpisodes: firestoreAction(context => {
      return context.bindFirestoreRef('episodes', db.collection('episodios').orderBy('numero'))
    })
  },
  modules: {
  }
})
